import {compressToUTF16} from 'lz-string';
import {format, isDate, parseISO, eachDayOfInterval} from 'date-fns';
import enUS from 'date-fns/locale/en-US';
import it from 'date-fns/locale/it';
import es from 'date-fns/locale/es';

import BrainIcon from '@components/Icons/BrainIcon';
import HandshakeIcon from '@components/Icons/HandshakeIcon';
import TargetIcon from '@components/Icons/TargetIcon';
import GearsIcon from '@components/Icons/GearsIcon';
import ScaleIcon from '@components/Icons/ScaleIcon';
import DigitalIcon from '@components/Icons/DigitalIcon';
import MotivationIcon from '@components/Icons/MotivationIcon';

import config from 'config';

export function getSuffix() {
  return window.location.href.includes('.cc') ? '' : 'Coreconsulting';
}

// Transform an Immutablejs value into a JS one in a safe way
export function toJS(immutableValue, defaultValue = {}) {
  return (immutableValue && immutableValue.toJS && immutableValue.toJS()) || defaultValue;
}

export function checkStringsEq(a, b) {
  if ((!a || !b) && a !== b) {
    return false;
  }

  if (typeof a !== 'string' || typeof b !== 'string') {
    return false;
  }

  return a.toLowerCase() === b.toLowerCase();
}

export function extractTranslatedLabel(item, lang, key = 'label') {
  const labels = item && item.get('labels');
  const translation = labels && labels.find(l => l.get('lang') === lang);

  let fallback;
  if (!translation) {
    fallback = labels && labels.find(l => l.get('lang') === 'IT_it');
  }

  let extractedLabel = '';
  if (translation) extractedLabel = translation.get(key);
  else if (fallback) extractedLabel = extractedLabel = fallback.get(key);
  else if (item.get(key)) {
    extractedLabel = item.get(key);
  }

  return extractedLabel;
  // return translation ? translation.get(key) : fallback ? fallback.get(key) : '';
}

export function compressData(data) {
  const source = typeof data !== 'string' ? JSON.stringify(data) : data;

  return compressToUTF16(source);
}

export function getReportUrl(reportId, campaignId, userId) {
  return `${config.api}/reports/${reportId}/run/${campaignId}${userId ? '/' + userId : ''}`;
}

export function getAreaIcon(areaId) {
  if (areaId === 1) {
    return BrainIcon;
  }

  if (areaId === 2) {
    return HandshakeIcon;
  }

  if (areaId === 3) {
    return TargetIcon;
  }

  if (areaId === 4) {
    return GearsIcon;
  }

  if (areaId === 5) {
    return ScaleIcon;
  }

  if (areaId === 6) {
    return MotivationIcon;
  }

  if (areaId === 7) {
    return DigitalIcon;
  }

  return BrainIcon;
}

export function roundToFirstDecimal(number) {
  if (Number.isInteger(number)) {
    return `${number}.0`;
  }

  return Math.round(number * 10) / 10;
}

export function getOldStateBackupKeys(state) {
  let keys = [];

  const stateKeys = Object.keys(state);
  for (let key of stateKeys) {
    if (state[key].data && state[key].version && state[key].status) {
      keys.push(key);
    }
  }

  return keys;
}

export const THEMES = {
  BASIC: 'skillup',
  CALENDAR: 'calendar',
  FERRARI: 'ferrari-academy',
};

export const weekdayNames = {
  it: ['Dom', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sab'],
  en: ['Sun', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Sat'],
};
export const weekdayNamesShort = {
  it: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
  en: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
};

export const monthNamesShort = [
  'Gennaio',
  'Febbraio',
  'Marzo',
  'Aprile',
  'Maggio',
  'Giugno',
  'Luglio',
  'Agosto',
  'Settembre',
  'Ottobre',
  'Novembre',
  'Dicembre',
];

const locales = {en: enUS, es, it};
// by providing a default string of 'PP' or any of its variants for `formatStr`
// it will format dates in whichever way is appropriate to the locale
export function formatDate(date, formatStr = 'PP', lang) {
  const _date = isDate(date) ? date : parseISO(date);
  let _lang = lang;

  if (_lang) {
    _lang = _lang.split('_')[0].toLowerCase();
  }

  return format(_date, formatStr, {
    locale: locales[_lang || 'it'], // or global.__localeId__
  });
}
